<div class="create-player-container">
    <h2>Crear jugador</h2>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="fill">
            <mat-label>Id</mat-label>
            <input matInput formControlName="playerId" />
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Label</mat-label>
            <input matInput formControlName="playerLabel" />
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="playerName" />
        </mat-form-field>

        <div class="buttons">
            <button matButton="filled" type="submit" [disabled]="form.invalid">Guardar</button>
            <button matButton="outlined" type="button" (click)="exit()">Salir</button>
        </div>

    </form>
</div>